export default "__VITE_ASSET__CdCNaCvH__"